const ResourceType: Record<ResourceType, ResourceType> = {
  Article: "Article",
  File: "File",
  Video: "Video",
};

const NonShareableResourceTitles = {
  RelapsePrevention: "Relapse Prevention Plan Template",
} as const;

enum ExploreThemeType {
  MostPopularVideos = "Most Popular Videos",
}

const PreserveOrderContentThemeCode = {
  DailyEducation: "DAILY_EDUCATION",
  MealCoaching: "MEAL_COACHING",
  SOTWAdolescentPatient: "SOTW_ADOLESCENT_PATIENT",
  SOTWAdultPatient: "SOTW_ADULT_PATIENT",
  SOTWProxy: "SOTW_PROXY",
} as const;

const PreserveOrderContentThemeCodes: ReadonlySet<string> = new Set([
  PreserveOrderContentThemeCode.DailyEducation,
  PreserveOrderContentThemeCode.MealCoaching,
  PreserveOrderContentThemeCode.SOTWAdolescentPatient,
  PreserveOrderContentThemeCode.SOTWAdultPatient,
  PreserveOrderContentThemeCode.SOTWProxy,
]);

enum ExploreResourcesOverviewCardSize {
  Height = 204,
  Width = 240,
}

enum ExploreTabSubDeepLinks {
  SearchGroups = "search-groups",
  VideoContent = "video-content",
}

export {
  ExploreResourcesOverviewCardSize,
  ExploreTabSubDeepLinks,
  ExploreThemeType,
  NonShareableResourceTitles,
  PreserveOrderContentThemeCode,
  PreserveOrderContentThemeCodes,
  ResourceType,
};
